import {NgModule} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {FuseDrawerModule} from '@scientifica-cms-fe/components/drawer';
import {LayoutComponent} from 'app/layout/layout.component';
import {EmptyLayoutModule} from 'app/layout/layouts/empty/empty.module';
import {ModernLayoutModule} from 'app/layout/layouts/horizontal/modern/modern.module';
import {SettingsModule} from 'app/layout/common/settings/settings.module';
import {SharedModule} from 'app/shared/shared.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';

const layoutModules = [
    // Empty
    EmptyLayoutModule,

    // Horizontal navigation
    ModernLayoutModule,

    // Vertical navigation
];

@NgModule({
    declarations: [
        LayoutComponent
    ],
    imports: [
        MatIconModule,
        MatTooltipModule,
        MatProgressBarModule,
        FuseDrawerModule,
        SharedModule,
        SettingsModule,
        ...layoutModules,
    ],

    exports: [
        LayoutComponent,
        ...layoutModules
    ]
})
export class LayoutModule {
}
